(function ($) {

  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the blockname-block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @return  void
   */
  const modal = $('#modal_team');
  const modalTeamImg = $('#modal_team_img');
  const modalTeamName = $('#modal_team_name');
  const modalTeamRole = $('#modal_team_role');
  const modalTeamContent = $('#modal_team_content');



  const initializeBlock = function ($block) {
    $('.modal').on('click', function () {
      var data = {
        'action': 'getTeamData',
        'team_id': $(this).data('team_id'),
      };
      $.post(teamAjax.ajaxurl, data, function(response) {
        modalTeamImg.attr('src', response.team_image);
        modalTeamName.text(response.team_name);
        modalTeamRole.text(response.team_role);
        modalTeamContent.html(response.team_content);
        modal.toggle()
      }, 'json');

    });
    $(".close-modal-team").on('click', function() {
      modal.toggle();
    });
  }


  // Initialize each block on page load (front end).
  $(document).ready(function () {
    initializeBlock();
  });

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=team-members-block', initializeBlock);
  }

})(jQuery);
